import axios from "axios";

const getCalendarData = (configuration) => {
  if (!configuration) {
    return axios
      .get("/api/calendar/getcalendardata", {
        params: {
          calendarOption: getElementValue("calendarOption"),
          language: getElementValue("languageCode"),
          startPageId: getElementValue("startPageId"),
          miniCalendar: getElementValue("miniCalendar"),
        }
      })
      .then((response) => response.data);
  }

  return axios
  .get("/api/calendar/getminicalendardata", {
    params: {
      calendarOption: configuration.calendarOption,
      language: configuration.languageCode,
      startPageId: configuration.startPageId,
      miniCalendar: configuration.miniCalendar,
      categoryIds: configuration.categoryIds.join(','),
      isStartPage: configuration.isStartPage,
    }
  })
  .then((response) => {
    return response.data;
  });
};

export {
  getCalendarData,
};

const getElementValue = (id) => {
  const element = document.getElementById(id);
  return element ? element.value : undefined;
};
